// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  zoneId: __t.u64().primaryKey().name("zone_id"),
  worldId: __t.u64().name("world_id"),
  name: __t.string(),
  audioAssetId: __t.u64().name("audio_asset_id"),
  kind: __t.string(),
  shapeType: __t.string().name("shape_type"),
  cx: __t.f32(),
  cy: __t.f32(),
  cz: __t.f32(),
  radius: __t.f32(),
  sx: __t.f32(),
  sy: __t.f32(),
  sz: __t.f32(),
  gain: __t.f32(),
  loop: __t.bool(),
  fadeDuration: __t.f32().name("fade_duration"),
  priority: __t.i32(),
});
